module.exports = __webpack_public_path__ + "img/1.42adf3f5.png";